<section *ngIf="slug"
         class="ci-panel__transition-bg fadein animation-duration-500"
         [ngClass]="{'ci-bg--yellow-traffic': allMessages[currentMessageIndex]?.type === 'warning',
                     'ci-bg--red': allMessages[currentMessageIndex]?.type === 'danger'}">
  <div #marqueeItem
       *ngIf="messages.length > 0"
       class="ci-panel__marquee-item ci-panel__marquee-item-animation {{customClass}}">
    <i class="bi {{allMessages[currentMessageIndex]?.icon}} ci-txt--black"
       [ngClass]="{'ci-txt--black': allMessages[currentMessageIndex]?.type === 'warning'}"
       [ngClass]="{'ci-txt--white': allMessages[currentMessageIndex]?.type === 'danger'}"></i>

    <span class="ci-txt--black"
          [ngClass]="{'ci-txt--black': allMessages[currentMessageIndex]?.type === 'warning'}"
          [ngClass]="{'ci-txt--white': allMessages[currentMessageIndex]?.type === 'danger'}">
      {{ allMessages[currentMessageIndex]?.text }}
    </span>
  </div>
</section>

<section *ngIf="messages.length === 0" class="bg-black-alpha-20 flex justify-content-center align-items-center shadow-1">
  <i class="bi bi-arrow-clockwise ci-txt--white ci-rotate"></i>
</section>
